import React from "react";
import styles from "./pdf.module.css";
import ResultCard from "../SWPCalculatorResult";
import Header from "./Header";
import Footer from "./Footer"

const formatIndianNumber = (num) => {
  return Number(num).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const InflationReport = (props) => { 
  const { form,resultCard } = props;  
  return (
    <div>
      {/* Header */}
      <div className={styles.pdf_child_container}>
        <div className={styles.pdf_card}   style={{ paddingBottom: "7rem",paddingLeft:"0",paddingRight:0 }} >
        <h2 className={styles.pdf_title}>SWP Calculator Report</h2> 
        {/* Investment Parameters */}
        <div className={styles.pdf_section}>INPUT DETAILS</div>

        <table className={styles.pdf_input_table}>
          <tr>
            <th>
             Particulars
            </th>
            <th>
              Details
            </th>
          </tr>
          <tr>
            <td>
              TOTAL AMOUNT IN FUNDS
            </td>
            <td>
             ₹{" "} {formatIndianNumber(form.totalAmount)}
            </td>
          </tr>
          <tr>
            <td>
             MONTHLY EXPENSES
            </td>
            <td>
             ₹{" "} {formatIndianNumber(form.monthlyExpense)}
            </td>
          </tr>
          <tr>
            <td>
             YEARLY EXPENSES (12 MONTHS)
            </td>
            <td>
             ₹{" "} {formatIndianNumber(form.yearlyExpense)}
            </td>
          </tr>
           <tr>
            <td>
            ASSET ALLOCATION DEBT
            </td>
            <td>
              {(form.assetAllocationDebt)}%
            </td>
          </tr>
          <tr>
            <td>
            ASSET ALLOCATION EQUITY
            </td>
            <td>
              {(form.assetAllocationEquity)}%
            </td>
          </tr>
           <tr>
            <td>
           EXPECTED EQUITY RETURNS
            </td>
            <td>
              {(form.expectedEquityReturns)}%
            </td>
          </tr>
          <tr>
            <td>
           EXPECTED DEBT RETURNS
            </td>
            <td>
              {(form.expectedDebtReturns)}%
            </td>
          </tr>
          <tr>
            <td>
           YEARLY EXPENSE INFLATION
            </td>
            <td>
              {(form.yearlyExpenseInflation)}%
            </td>
          </tr>
           <tr>
            <td>
           WITHDRAWAL % PER YEAR
            </td>
            <td>
              {(form.withdrawalRate)}
            </td>
          </tr>
        </table>

        <div
          style={{
            height: "4px",
            backgroundColor: "rgb(185, 28, 28)",
            marginTop: "6.5rem",
            width: "100%",
          }}
        />

        <Footer pageNumber={0} totalPages={0}/>
        <div>&nbsp;</div>
        <Header/>
        <div
          style={{
            height: "4px",
            backgroundColor: "rgb(185, 28, 28)",
            marginTop:"10px",
            marginBottom:"1rem",
            width: "100%",
          }}
        />
        <div className={styles.pdf_result_header}>
        <div className={styles.pdf_section}>SUMMARY</div>
        <div className={styles.pdf_section_light}>
          Generated on {new Date().toLocaleDateString()}
        </div>
        </div>
        <ResultCard results={resultCard} variant="pdf"/>
        <p className={styles.pdf_declaration}>* The above values are estimated based on the assumed rate of return and may vary with market conditions.</p>
        </div>
      </div>
    </div>
  );
};

export default InflationReport;